import React from "react";

import { ButtonBase, Typography, alpha, useTheme } from "@mui/material";

import {
  focusRing,
  reducedMotion,
} from "@dashboard/components/themes/themeMotion";

/** The pill button used in the preview modal and its sheets. */
export const SheetButton = ({
  primary = false,
  small = false,
  disabled,
  onClick,
  children,
  ...rest
}: {
  primary?: boolean;
  small?: boolean;
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
} & Pick<React.AriaAttributes, "aria-haspopup">) => {
  const { palette } = useTheme();
  const oscar = palette.oscar.light;

  return (
    <ButtonBase
      {...rest}
      onClick={onClick}
      disabled={disabled}
      sx={[
        {
          flexShrink: 0,
          height: small ? 36 : 40,
          px: small ? 2.25 : 2.5,
          borderRadius: "24px",
          border: primary ? 0 : `1px solid ${oscar.button.mid}`,
          background: primary ? oscar.content.content1 : oscar.surface.clear,
          opacity: disabled ? 0.6 : 1,
          transition: "background 150ms ease-out",
          "&:hover": {
            background: primary
              ? alpha(oscar.content.content1, 0.85)
              : oscar.surface.neutral,
          },
        },
        focusRing(),
        reducedMotion,
      ]}
    >
      <Typography
        variant={small ? "labelSMedium" : "labelRMedium"}
        sx={{
          fontSize: small ? 13 : undefined,
          color: primary ? oscar.surface.clear : oscar.content.content1,
        }}
      >
        {children}
      </Typography>
    </ButtonBase>
  );
};
